module.exports = __webpack_public_path__ + "static/media/logo2.29c644f4.png";